import type { TechnologyNode } from "../../domain/model";
import { CapabilityMark } from "../../components/CapabilityMark";

export function MobileNodeList({ nodes, onSelect }: { nodes: TechnologyNode[]; onSelect: (node: TechnologyNode) => void }) {
  const layers = Array.from(new Set(nodes.map((node) => node.layer)));
  return (
    <div className="mobile-node-list">
      {layers.map((layer) => (
        <section key={layer}>
          <h3>{layer}</h3>
          {nodes.filter((node) => node.layer === layer).map((node) => (
            <button key={node.id} onClick={() => onSelect(node)}>
              <span><strong>{node.name}</strong><small>{node.summary}</small></span>
              <CapabilityMark state={node.capabilityState} compact />
            </button>
          ))}
        </section>
      ))}
    </div>
  );
}
